export class PermissionDataModel {

    permissionListModel = [
        {
            permissionId: 1,
            permissionName: 'ViewAccounts',
            displayName: 'Access to Accounts Module',
            isChecked: false
        },
        {
            permissionId: 2,
            permissionName: 'ViewCustomer',
            displayName: 'Access to Accounts Customer Module',
            isChecked: false
        },
        {
            permissionId: 7,
            permissionName: 'ViewLead',
            displayName: 'Access to Accounts Lead Modules',
            isChecked: false
        },
        {
            permissionId: 12,
            permissionName: 'ViewContacts',
            displayName: 'Access to Accounts Contact',
            isChecked: false
        },
        {
            permissionId: 13,
            permissionName: 'Jobs',
            displayName: 'Jobs',
            isChecked: false
        },
        {
            permissionId: 14,
            permissionName: 'Quotes',
            displayName: 'Quotes',
            isChecked: false
        },
        {
            permissionId: 15,
            permissionName: 'QuickQuotes',
            displayName: 'QuickQuotes',
            isChecked: false
        },
        {
            permissionId: 16,
            permissionName: 'CreateJobs',
            displayName: 'CreateJobs',
            isChecked: false
        },
        {
            permissionId: 17,
            permissionName: 'UpdateJobs',
            displayName: 'UpdateJobs',
            isChecked: false
        },
        {
            permissionId: 18,
            permissionName: 'ViewJobs',
            displayName: 'ViewJobs',
            isChecked: false
        },
        {
            permissionId: 19,
            permissionName: 'DeleteJobs',
            displayName: 'DeleteJobs',
            isChecked: false
        },
        {
            permissionId: 20,
            permissionName: 'CreateQuote',
            displayName: 'CreateQuote',
            isChecked: false
        },
        {
            permissionId: 21,
            permissionName: 'UpdateQuote',
            displayName: 'UpdateQuote',
            isChecked: false
        },
        {
            permissionId: 22,
            permissionName: 'ViewQuote',
            displayName: 'ViewQuote',
            isChecked: false
        },
        {
            permissionId: 23,
            permissionName: 'DeleteQuote',
            displayName: 'DeleteQuote',
            isChecked: false
        },
        {
            permissionId: 24,
            permissionName: 'CreateQuickQuote',
            displayName: 'CreateQuickQuote',
            isChecked: false
        },
        {
            permissionId: 25,
            permissionName: 'UpdateQuickQuote',
            displayName: 'UpdateQuickQuote',
            isChecked: false
        },
        {
            permissionId: 26,
            permissionName: 'ViewQuickQuote',
            displayName: 'ViewQuickQuote',
            isChecked: false
        },
        {
            permissionId: 27,
            permissionName: 'DeleteQuickQuote',
            displayName: 'DeleteQuickQuote',
            isChecked: false
        },
        {
            permissionId: 28,
            permissionName: 'ViewQuickCutsheet',
            displayName: 'ViewQuickCutsheet',
            isChecked: false
        },
        {
            permissionId: 29,
            permissionName: 'ExcessValue',
            displayName: 'ExcessValue',
            isChecked: false
        },
        {
            permissionId: 30,
            permissionName: 'JobsAppointments',
            displayName: 'JobsAppointments',
            isChecked: false
        },
        {
            permissionId: 31,
            permissionName: 'Documents',
            displayName: 'Documents',
            isChecked: false
        },
        {
            permissionId: 32,
            permissionName: 'JobsDocumentsAdminRequest',
            displayName: 'JobsDocumentsAdminRequest',
            isChecked: false
        },
        {
            permissionId: 33,
            permissionName: 'JobsDocumentsAdminRequestRequestForPrice',
            displayName: 'JobsDocumentsAdminRequestRequestForPrice',
            isChecked: false
        },
        {
            permissionId: 34,
            permissionName: 'JobsDocumentsAdminRequestNotificationOfArrival',
            displayName: 'JobsDocumentsAdminRequestNotificationOfArrival',
            isChecked: false
        },
        {
            permissionId: 35,
            permissionName: 'MaterialList',
            displayName: 'MaterialList',
            isChecked: false
        },
        {
            permissionId: 36,
            permissionName: 'ViewInvoice',
            displayName: 'ViewInvoice',
            isChecked: false
        },
        {
            permissionId: 37,
            permissionName: 'AllInvoice',
            displayName: 'AllInvoice',
            isChecked: false
        },
        {
            permissionId: 38,
            permissionName: 'InvoiceInvoiceAging',
            displayName: 'InvoiceInvoiceAging',
            isChecked: false
        },
        {
            permissionId: 39,
            permissionName: 'ViewReports',
            displayName: 'ViewReports',
            isChecked: false
        },
        {
            permissionId: 40,
            permissionName: 'ViewReportsRoyaltyReport',
            displayName: 'ViewReportsRoyaltyReport',
            isChecked: false
        },
        {
            permissionId: 41,
            permissionName: 'ViewReportsMarketing',
            displayName: 'ViewReportsMarketing',
            isChecked: false
        },
        {
            permissionId: 42,
            permissionName: 'ViewReportsInsurance',
            displayName: 'ViewReportsInsurance',
            isChecked: false
        },
        {
            permissionId: 43,
            permissionName: 'ViewReportsJobs',
            displayName: 'ViewReportsJobs',
            isChecked: false
        },
        {
            permissionId: 44,
            permissionName: 'ViewReportMyTerritory',
            displayName: 'ViewReportMyTerritory',
            isChecked: false
        },
        {
            permissionId: 45,
            permissionName: 'ViewReportsISPMLumber',
            displayName: 'ViewReportsISPMLumber',
            isChecked: false
        },
        {
            permissionId: 46,
            permissionName: 'RFQ',
            displayName: 'RFQ',
            isChecked: false
        },
        {
            permissionId: 47,
            permissionName: 'ViewAdminDashboard',
            displayName: 'ViewAdminDashboard',
            isChecked: false
        },
        {
            permissionId: 48,
            permissionName: 'ViewAdminAccountDemographies',
            displayName: 'ViewAdminAccountDemographies',
            isChecked: false
        },
        {
            permissionId: 49,
            permissionName: 'ViewAdminCreatingAndPackaging',
            displayName: 'ViewAdminCreatingAndPackaging',
            isChecked: false
        },
        {
            permissionId: 50,
            permissionName: 'ViewAdminDocuments',
            displayName: 'ViewAdminDocuments',
            isChecked: false
        },
        {
            permissionId: 51,
            permissionName: 'ViewAdminServiceAndInsurance',
            displayName: 'ViewAdminServiceAndInsurance',
            isChecked: false
        },
        {
            permissionId: 52,
            permissionName: 'ViewAdminMyFrenchise',
            displayName: 'ViewAdminMyFrenchise',
            isChecked: false
        },
        {
            permissionId: 53,
            permissionName: 'AdminCAndPContainers',
            displayName: 'AdminCAndPContainers',
            isChecked: false
        },
        {
            permissionId: 54,
            permissionName: 'AdminCAndPPackagings',
            displayName: 'AdminCAndPPackagings',
            isChecked: false
        },
        {
            permissionId: 55,
            permissionName: 'AdminCAndPMaterials',
            displayName: 'AdminCAndPMaterials',
            isChecked: false
        },
        {
            permissionId: 56,
            permissionName: 'AdminCAndPItems',
            displayName: 'AdminCAndPItems',
            isChecked: false
        },
        {
            permissionId: 57,
            permissionName: 'ViewAdminServiceAndInsuranceService',
            displayName: 'ViewAdminServiceAndInsuranceService',
            isChecked: false
        },
        {
            permissionId: 58,
            permissionName: 'ViewAdminServiceAndInsuranceInsurance',
            displayName: 'ViewAdminServiceAndInsuranceInsurance',
            isChecked: false
        },
        {
            permissionId: 59,
            permissionName: 'ViewAdminMyFrenchiseVehicles',
            displayName: 'ViewAdminMyFrenchiseVehicles',
            isChecked: false
        },
        {
            permissionId: 60,
            permissionName: 'ViewAdminMyFrenchiseCorporate',
            displayName: 'ViewAdminMyFrenchiseCorporate',
            isChecked: false
        },
        {
            permissionId: 61,
            permissionName: 'ViewAdminEmployees',
            displayName: 'ViewAdminEmployees',
            isChecked: false
        },
        {
            permissionId: 62,
            permissionName: 'ViewAdminGroups',
            displayName: 'ViewAdminGroups',
            isChecked: false
        },
        {
            permissionId: 93,
            permissionName: 'ViewAdminMyFrenchiseFrenchise',
            displayName: 'ViewAdminMyFrenchiseFrenchise',
            isChecked: false
        },
        {
            permissionId: 94,
            permissionName: 'QuotesExcessValue',
            displayName: 'QuotesExcessValue',
            isChecked: false
        },
        {
            permissionId: 95,
            permissionName: 'QuotesAppointments',
            displayName: 'QuotesAppointments',
            isChecked: false
        },
        {
            permissionId: 96,
            permissionName: 'QuotesDocuments',
            displayName: 'QuotesDocuments',
            isChecked: false
        },
        {
            permissionId: 97,
            permissionName: 'QuotesDocumentsAdminRequest',
            displayName: 'QuotesDocumentsAdminRequest',
            isChecked: false
        },
        {
            permissionId: 98,
            permissionName: 'QuotesDocumentsAdminRequestRequestForPrice',
            displayName: 'QuotesDocumentsAdminRequestRequestForPrice',
            isChecked: false
        },
        {
            permissionId: 99,
            permissionName: 'QuotesDocumentsAdminRequestNotificationOfArrival',
            displayName: 'QuotesDocumentsAdminRequestNotificationOfArrival',
            isChecked: false
        },
        {
            permissionId: 100,
            permissionName: 'QuotesMaterialList',
            displayName: 'QuotesMaterialList',
            isChecked: false
        },
        {
            permissionId: 101,
            permissionName: 'InShop',
            displayName: 'InShop',
            isChecked: false
        },
        {
            permissionId: 102,
            permissionName: 'OrderQuickSearch',
            displayName: 'OrderQuickSearch',
            isChecked: true
        },
        {
            permissionId: 103,
            permissionName: 'FreightView',
            displayName: 'FreightView',
            isChecked: false
        },
        {
            permissionId: 104,
            permissionName: 'Shipments',
            displayName: 'Shipments',
            isChecked: true
        },
        {
            permissionId: 105,
            permissionName: 'ViewSearch',
            displayName: 'Search',
            isChecked: true
        },
        {
            permissionId: 104,
            permissionName: 'ForumsandQuickLinks',
            displayName: 'ForumsandQuickLinks',
            isChecked: false
        },
        {
            permissionId: 105,
            permissionName: 'ViewMessage',
            displayName: 'ForumsAndQuickLinksDashboardWithMetricsAndStats',
            isChecked: false
        },
        {
            permissionId: 106,
            permissionName: 'FinalizeJobs',
            displayName: 'FinalizeJobs',
            isChecked: false
        },
        {
            permissionId: 107,
            permissionName: 'Impersonate',
            displayName: 'Impersonate',
            isChecked: false
        },

    ];

}
